import styled from '@emotion/styled';
import { Card } from 'antd';

export const StyledCard = styled(Card)`
  margin: 30px;
  min-width: 600px;
`;

export const HeaderSection = styled.div`
  padding: 24px 24px 0;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const HeaderMeta = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
  color: #555;
`;

export const HeaderLabel = styled.span`
  font-weight: 500;
`;

export const TokenText = styled.span`
  font-family: monospace;
`;

export const PageTitle = styled.div`
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 10px;
`;

export const BackLink = styled.div`
  margin-bottom: 16px;
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 4px;
`;

export const BodySection = styled.div`
  padding: 20px 24px;
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const SectionTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
`;

export const EmptyState = styled.div`
  color: #aaa;
  text-align: center;
  padding: 40px 0;
`;

export const HostCard = styled.div`
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  margin-bottom: 12px;
  overflow: hidden;
`;

export const HostRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #fafafa;
  cursor: pointer;
`;

export const HostRowLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const HostRowRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const HostMeta = styled.span`
  color: #888;
  font-size: 13px;
`;

export const PropertyRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px 10px 36px;
  background: #fff;
  cursor: pointer;
  border-top: 1px solid #f0f0f0;
`;

export const PropertyRowLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PropertyName = styled.span`
  font-weight: 500;
`;

export const PropertyMeta = styled.span`
  color: #aaa;
  font-size: 13px;
`;

export const MappingExpandedSection = styled.div`
  background: #fafeff;
  border-top: 1px solid #f5f5f5;
`;

export const MappingGroup = styled.div`
  padding: 8px 16px 8px 60px;
`;

export const MappingGroupLabel = styled.div`
  font-size: 11px;
  color: #aaa;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 6px;
`;

export const MappingTagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const NoPropertiesText = styled.div`
  padding: 12px 24px;
  color: #aaa;
  font-size: 13px;
`;
